export default {
  dadosEncarte: {},
  listaCampanhas: [],
  smsCredits: {},
  smsCountsChanged: false,
  smsCostMessage: 1,
  activeCampaignsQuarter: [],
  resultadosDaCampanha: {},
  campaignMetrics: {},
  segmentos: [],
}
